import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminArticles`;
const CREATE_ARTICLE = `${MAIN_URL}/createArticle`;
const GET_ARTICLE = `${MAIN_URL}/getArticles`;
const GET_ARTICLE_BY_ID = `${MAIN_URL}/getArticle`;
const UPDATE_ARTICLE = `${MAIN_URL}/updateArticle`;
const DELETE_ARTICLE = `${MAIN_URL}/deleteArticle`;
const GET_MAGZINE_DAIRY = `${MAIN_URL}/getMagazinesAndDiaries`;
const UPDATE_PREVEIW_ARTICLE = `${MAIN_URL}/updatePreviewArticle`;
const STAR_ARTICLE = `${MAIN_URL}/starArticle`;



const GET_REVIEW_ARTICLE = `${MAIN_URL}/getPendingArticles`;

// Create a new article
export async function createArticle(token, data) {
  try {
    const response = await axios.post(CREATE_ARTICLE, data, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error creating article:", error);
    return { Result: false, Msg: "Error creating article" };
  }
}

// Get all articles
export async function getArticle(token) {
  try {
    const response = await axios.get(GET_ARTICLE, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching articles:", error);
    return { Result: false, Msg: "Error fetching articles" };
  }
}

// Get article by ID
export async function getArticleById(token, id) {
  try {
    const response = await axios.get(`${GET_ARTICLE_BY_ID}/${id}`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching article by ID:", error);
    return { Result: false, Msg: "Error fetching article" };
  }
}

// Update an existing article
export async function updateArticle(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_ARTICLE}/${id}`, data, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating article:", error);
    return { Result: false, Msg: "Error updating article" };
  }
}

// Delete an article
export async function deleteArticle(token, id) {
  try {
    const response = await axios.delete(`${DELETE_ARTICLE}/${id}`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting article:", error);
    return { Result: false, Msg: "Error deleting article" };
  }
}
export async function starArticle(token, id) {
  try {
    const response = await axios.patch(`${STAR_ARTICLE}/${id}`,{}, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error Staring article:", error);
    return { Result: false, Msg: "Error Staring article" };
  }
}

// get Articles For Reviews

export async function getReviewArticle(token) {
  try {
    const response = await axios.get(GET_REVIEW_ARTICLE, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching articles:", error);
    return { Result: false, Msg: "Error fetching articles" };
  }
}


export async function getMagzineAndDairy(token) {
  try {
    const response = await axios.get(GET_MAGZINE_DAIRY, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching data:", error);
    return { Result: false, Msg: "Error fetching articles" };
  }
}



export async function updatePreviewArticle(token, id) {
  try {
    const response = await axios.put(`${UPDATE_PREVEIW_ARTICLE}/${id}`,{},{
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating article:", error);
    return { Result: false, Msg: "Error updating article" };
  }
}